import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, FieldTypes, useResponsive } from '@common-fe/common-fe';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';
import masks from '@/common/masks';
import REGEXP from '@/common/regexp';
import { VerificationErrorText } from '@/modules/user/components/Verification/verification.types';

const CODE_LENGTH = 6;

export interface FormValues {
  verificationCode: string;
}

interface Props {
  verificationErrorText?: string;
}

const useVerificationCodeFields = ({ verificationErrorText }: Props) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const fields = useMemo<Field[]>(
    () => [
      {
        name: 'verificationCode',
        type: FieldTypes.Mask,
        label: 'Verification code',
        placeholder: 'Verification code',
        showRequireIcon: true,
        mask: masks.VERIFYING_CODE,
        style: isMobile ? undefined : { display: 'grid', gridTemplateColumns: 'minmax(200px, 1fr) 320px' },
        validator: yup
          .string()
          .test({
            test: (verificationCode) =>
              verificationCode?.replace(REGEXP.SPACE_SYMBOL, '').length === CODE_LENGTH &&
              !verificationErrorText,
            message: VerificationErrorText.CODE_IS_INVALID,
          })
          .required(t(REQUIRED_TEXT)),
      },
    ],
    [t, verificationErrorText, isMobile]
  );

  return fields;
};

export default useVerificationCodeFields;
